"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _articlesSection = require("./articlesSection");
Object.keys(_articlesSection).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _articlesSection[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _articlesSection[key];
        }
    });
});
var _categoriesSection = require("./categoriesSection");
Object.keys(_categoriesSection).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _categoriesSection[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _categoriesSection[key];
        }
    });
});
var _categoryBox = require("./categoryBox");
Object.keys(_categoryBox).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _categoryBox[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _categoryBox[key];
        }
    });
});
var _description = require("./description");
Object.keys(_description).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _description[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _description[key];
        }
    });
});
var _title = require("./title");
Object.keys(_title).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _title[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _title[key];
        }
    });
});
var _editorialCarousel = require("./editorialCarousel");
Object.keys(_editorialCarousel).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _editorialCarousel[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _editorialCarousel[key];
        }
    });
});
